// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bb-0";
export var orangeButton = "_bb-1";